import request from '@/utils/request'

export function getSystemBasicConfig() {
  return request('/api/admin/system/basic-config')
}

export function updateSystemBasicConfig(payload) {
  return request('/api/admin/system/basic-config', {
    method: 'PUT',
    body: payload
  })
}

export function uploadSystemLogo(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request('/api/files/upload-image', {
    method: 'POST',
    body: formData
  })
}
